"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var _ = __importStar(require("lodash"));
var Profile_1 = require("./Profile");
var profile_icon_svg_1 = __importDefault(require("res/img/profile-icon.svg"));
var password_icon_svg_1 = __importDefault(require("res/img/password-icon.svg"));
var ProfileMenu = function (_a) {
    var page = _a.page, onChangePage = _a.onChangePage;
    return (react_1.default.createElement("ul", { className: 'settings-menu', role: 'menu' },
        react_1.default.createElement("li", { className: 'flex flex-row', "aria-selected": page === Profile_1.ProfilePages.BASIC_INFO, onClick: function () { return onChangePage(Profile_1.ProfilePages.BASIC_INFO); }, role: 'menuitem' },
            react_1.default.createElement("img", { src: profile_icon_svg_1.default, alt: "" + _.startCase(Profile_1.ProfilePages.BASIC_INFO) }),
            react_1.default.createElement("span", null, _.startCase(Profile_1.ProfilePages.BASIC_INFO))),
        react_1.default.createElement("li", { className: 'flex flex-row', "aria-selected": page === Profile_1.ProfilePages.CHANGE_PASSWORD, onClick: function () { return onChangePage(Profile_1.ProfilePages.CHANGE_PASSWORD); }, role: 'menuitem' },
            react_1.default.createElement("img", { src: password_icon_svg_1.default, alt: "" + _.startCase(Profile_1.ProfilePages.CHANGE_PASSWORD) }),
            react_1.default.createElement("span", null, _.startCase(Profile_1.ProfilePages.CHANGE_PASSWORD)))));
};
exports.default = ProfileMenu;
